import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import Alert from "./../../common/alert/Alert";
import { Row, Col, FormGroup, FormLabel, FormControl, FormCheck } from "react-bootstrap";
import AppModal from "../../common/modal/AppModal";
import { Typeahead } from "react-bootstrap-typeahead";
import {
  ID_PREFIX_RICH_MARK,
  ID_PREFIX_SORTABLE_BOX,
  ID_PREFIX_CONTAINED_VIEW,
  PAGE_TYPES,
  ID_PREFIX_PAGE,
  ID_PREFIX_BOX,
} from "../../../../common/constants";
import i18n from "i18next";
import { isSection, isContainedView, nextAvailName } from "../../../../common/utils";
import "../rich_marks_modal/_richMarksModal.scss";
import IdealStudio from "../../../../core/editor/main";

import TemplatesModalRich from "../templates_modal/TemplatesModalRich";
import { createBox } from "../../../../common/common_tools";

import Swal from "sweetalert2";

/**
 * Modal component to edit marks' configuration
 */
export default class AddNewAnimationModal extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);
    /**
     * Component's initial state
     * @type {{connectMode: string, displayMode: string, newSelected: string, existingSelected: string, newType: string, viewNames: *, showAlert: boolean}}
     */
    this.state = {
      connectMode: "new",
      displayMode: "navigate",
      newSelected: this.props.navItems[this.props.navItemSelected]
        ? this.props.navItems[this.props.navItemSelected].type
        : "",
      existingSelected: "",
      newType: PAGE_TYPES.SLIDE,
      viewNames: this.returnAllViews(this.props),
      showAlert: false,
      showTemplates: false,
      boxes: [],
      animationList: [],
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleTemplatesModal = this.toggleTemplatesModal.bind(this);
    this.templateClick = this.templateClick.bind(this);
  }

  /**
   * Before component receives props
   * Updates component's state with toolbar's state info
   * @param nextProps
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.boxSelected != -1 && !this.props.visible && nextProps.visible) {
      let box = nextProps.box;

      // A box with no animations yet has `animationById === undefined` (it's
      // animationsById[boxSelected]); default to [] so opening the modal to add a
      // FIRST animation doesn't crash on .map (the constructor already seeds []).
      let animationList = nextProps.animationById || [];

      let boxdiv = document.getElementById("box-" + box.id);

      this.setState({
        animationList: animationList.map((anim) => {
          return {
            positionx: anim.positionx || "0%",
            positiony: anim.positiony || "0%",
            opacity: anim.opacity !== undefined ? anim.opacity : 1,
            width: anim.width || "25%",
            duration: anim.duration ? anim.duration : 0,
          };
        }),
      });
    }

    let current = nextProps.currentRichMark;
    let allViews = this.returnAllViews(nextProps);
    let currentViewType =
      this.props.containedViewSelected === 0
        ? this.props.navItems[this.props.navItemSelected].type
        : this.props.containedViews[this.props.containedViewSelected].type;
    if (!this.props.visible) {
      if (current) {
        this.setState({
          viewNames: allViews,
          color: current.color,
          connectMode: current.connectMode || "new",
          displayMode: current.displayMode || "navigate",
          newSelected: current.connectMode === "new" ? current.connection : "",
          newType: nextProps.navItems[nextProps.navItemSelected]
            ? nextProps.navItems[nextProps.navItemSelected].type
            : "",
          existingSelected:
            current.connectMode === "existing" &&
            this.remapInObject(nextProps.navItems, nextProps.containedViews)[current.connection]
              ? this.remapInObject(nextProps.navItems, nextProps.containedViews)[current.connection]
                  .id
              : "",
        });
      } else {
        this.setState({
          viewNames: allViews,
          color: null,
          connectMode: "new",
          displayMode: "navigate",
          newSelected: "",
          newType: nextProps.navItems[nextProps.navItemSelected]
            ? nextProps.navItems[nextProps.navItemSelected].type
            : "",
          existingSelected: "",
        });
      }
    }
  }

  /**
   * Render React Component
   * @returns {code}
   */
  render() {
    let box = this.props.box;
    let animationList = this.state.animationList;

    let richMarkValue = null;
    let marksType =
      this.props.pluginToolbar &&
      this.props.pluginToolbar.pluginId &&
      IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId) &&
      IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId).getConfig() &&
      IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId).getConfig().marksType
        ? IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId).getConfig().marksType
        : {};
    function getRichMarkInput(value) {
      richMarkValue = value;
    }
    let current = this.props.currentRichMark;
    let selected =
      this.state.existingSelected &&
      (this.props.containedViews[this.state.existingSelected] ||
        this.props.navItems[this.state.existingSelected])
        ? isContainedView(this.state.existingSelected)
          ? {
              label: this.props.containedViews[this.state.existingSelected].name,
              id: this.state.existingSelected,
            }
          : {
              label: this.props.navItems[this.state.existingSelected].name,
              id: this.state.existingSelected,
            }
        : this.returnAllViews(this.props)[0] || [];
    let newSelected = "";
    if (this.props.viewToolbars[this.state.newSelected] !== undefined) {
      newSelected = this.props.viewToolbars[this.state.newSelected].viewName;
    }
    let currentNavItemType = this.props.navItems[this.props.navItemSelected].type;
    let plugin =
      this.props.pluginToolbar &&
      this.props.pluginToolbar.pluginId &&
      IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId)
        ? IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId)
        : undefined;
    let defaultMarkValue = plugin
      ? IdealStudio.Plugins.get(this.props.pluginToolbar.pluginId).getDefaultMarkValue(
          this.props.pluginToolbar.state,
          this.props.boxSelected
        )
      : "";
    let pluginType =
      this.props.pluginToolbar && this.props.pluginToolbar.config
        ? this.props.pluginToolbar.config.displayName
        : "Plugin";
    let config = plugin ? plugin.getConfig() : null;
    let newId = "";

    const handleCancel = () => {
      this.props.onAddNewAnimationModalToggled();
      this.restoreDefaultTemplate();
    };
    const handleSave = () => {
      if (this.state.animationList.length < 2) {
        this.props.onSaveNewAnimation(box.id, []);
        this.restoreDefaultTemplate();
        this.props.onAddNewAnimationModalToggled();
        return;
      } else if (this.state.animationList.filter((r) => r.duration != 0).length == 0) {
        Swal.fire({
          title: "Sürelerin hepsi 0 olamaz",
          icon: "warning",
          width: 600,
          showCancelButton: false,
          allowOutsideClick: false,
          confirmButtonText: "Tamam",
        });
        return;
      }
      this.props.onSaveNewAnimation(box.id, this.state.animationList);
      this.restoreDefaultTemplate();
      this.props.onAddNewAnimationModalToggled();
    };

    return (
      <AppModal
        className="richMarksModal addAnimationModal"
        backdrop
        size="lg"
        show={this.props.visible}
        onClose={handleCancel}
        style={{ minWidth: "80%" }}
        title={
          <>
            <i style={{ fontSize: "18px" }} className="material-icons">
              room
            </i>{" "}
            {current
              ? IdealStudio.i18n.t("Animation.edit_animation")
              : IdealStudio.i18n.t("Animation.add_animation")}
          </>
        }
        cancelLabel={i18n.t("Cancel")}
        onCancel={handleCancel}
        confirmLabel={i18n.t("marks.save_changes")}
        onConfirm={handleSave}
      >
        <Row>
          <Col xs={1} md={1}>
            <FormLabel>{IdealStudio.i18n.t("No")}</FormLabel>
          </Col>
          <Col xs={10} md={10} style={{ padding: 0 }}>
            <Col xs={2} md={2}>
              <FormLabel>{IdealStudio.i18n.t("Animation.PositionX")}</FormLabel>
            </Col>
            <Col xs={2} md={2}>
              <FormLabel>{IdealStudio.i18n.t("Animation.PositionY")}</FormLabel>
            </Col>
            <Col xs={2} md={2}>
              <FormLabel>{IdealStudio.i18n.t("Animation.Opacity")}</FormLabel>
            </Col>
            <Col xs={2} md={2}>
              <FormLabel>{IdealStudio.i18n.t("Animation.Width")}</FormLabel>
            </Col>
            <Col xs={4} md={4}>
              <FormLabel>{IdealStudio.i18n.t("Animation.Duration")}</FormLabel>
            </Col>
          </Col>

          <Col xs={1} md={1} />
        </Row>
        {animationList.map((anim, i) => (
          <Row>
            <Col xs={1} md={1}>
              <FormLabel>{i + 1}</FormLabel>
            </Col>
            <Col xs={10} md={10} style={{ padding: 0 }}>
              <Col xs={2} md={2}>
                <FormControl
                  type="number"
                  min="0"
                  max="100"
                  step="0.01"
                  value={(anim.positionx || "0%").replace("%", "")}
                  onChange={(e) =>
                    this.setState({
                      animationList: this.state.animationList.map((obj) => {
                        if (this.state.animationList.indexOf(obj) == i) {
                          return { ...obj, positionx: e.target.value + "%" };
                        }
                        return obj;
                      }),
                    })
                  }
                />
              </Col>
              <Col xs={2} md={2}>
                <FormControl
                  type="number"
                  min="0"
                  max="100"
                  step="0.01"
                  value={(anim.positiony || "0%").replace("%", "")}
                  onChange={(e) =>
                    this.setState({
                      animationList: this.state.animationList.map((obj) => {
                        if (this.state.animationList.indexOf(obj) == i) {
                          return { ...obj, positiony: e.target.value + "%" };
                        }
                        return obj;
                      }),
                    })
                  }
                />
              </Col>
              <Col xs={2} md={2}>
                <FormControl
                  type="number"
                  min="0"
                  max="1"
                  step="0.1"
                  value={anim.opacity !== undefined ? anim.opacity : 1}
                  onChange={(e) =>
                    this.setState({
                      animationList: this.state.animationList.map((obj) => {
                        if (this.state.animationList.indexOf(obj) == i) {
                          return { ...obj, opacity: e.target.value };
                        }
                        return obj;
                      }),
                    })
                  }
                />
              </Col>
              <Col xs={2} md={2}>
                <FormControl
                  type="number"
                  min="0"
                  max="100"
                  step="0.1"
                  value={(anim.width || "25%").replace("%", "")}
                  onChange={(e) =>
                    this.setState({
                      animationList: this.state.animationList.map((obj) => {
                        if (this.state.animationList.indexOf(obj) == i) {
                          return { ...obj, width: e.target.value + "%" };
                        }
                        return obj;
                      }),
                    })
                  }
                />
              </Col>
              <Col xs={4} md={4}>
                <FormControl
                  type="number"
                  min="0"
                  max="100"
                  value={anim.duration ? anim.duration : 0}
                  onChange={(e) =>
                    this.setState({
                      animationList: this.state.animationList.map((obj) => {
                        if (this.state.animationList.indexOf(obj) == i) {
                          return { ...obj, duration: e.target.value };
                        }
                        return obj;
                      }),
                    })
                  }
                />
              </Col>
            </Col>
            <Col xs={1} md={1}>
              <button
                type="button"
                className="app-modal__btn app-modal__btn--primary"
                onClick={() => {
                  if (this.state.animationList.length > 1) {
                    this.setState({
                      animationList: this.state.animationList.filter(
                        (r) => this.state.animationList.indexOf(r) != i
                      ),
                    });
                  }
                }}
              >
                -
              </button>
            </Col>
          </Row>
        ))}
        <Row>
          <Col xs={2} md={2}>
            <button
              type="button"
              className="app-modal__btn app-modal__btn--primary"
              onClick={() => {
                if (this.state.animationList.length < 10) {
                  this.setState({
                    animationList: this.state.animationList.concat({
                      positionx: "0%",
                      positiony: "0%",
                      opacity: 0,
                      width: "25%",
                      duration: 0,
                    }),
                  });
                }
              }}
            >
              {IdealStudio.i18n.t("Animation.position_add")}
            </button>
          </Col>

          <Col xs={3} md={3}>
            <button
              type="button"
              className="app-modal__btn app-modal__btn--ghost"
              onClick={() => {
                /*
                            let id = box.id;
                            let parent = box.parent;
                            let container = box.container;

                            this.setState({firstpositionx: "0",
                            firstpositiony: "0",
                            middlepositionx: "0",
                            middlepositiony: "0",
                            lastpositionx: "0",
                            lastpositiony: "0",
                            firstopacity: 0,
                            middleopacity: 0,
                            lastopacity: 0,
                            firstwidth: "0",
                            firstheight: "0",
                            middlewidth: "0",
                            middleheight: "0",
                            lastwidth: "0",
                            lastheight: "0",
                            firstduration: 0,
                            middleduration: 0,
                            lastduration: 0,
                            },() => {
                                this.props.onBoxStartAnimation(box.id, "0", "0", "0", "0", box.parent, box.container);
                                this.props.onBoxMiddleAnimation(box.id, "0", "0", "0", "0", box.parent, box.container);
                                this.props.onBoxEndAnimation(box.id, "0", "0","0","0", box.parent, box.container);
                                this.props.onBoxFinalAnimation(id,1,1,1,0,0,0,parent,container);
                            });
                            */

                this.setState(
                  {
                    animationList: [
                      {
                        positionx: "0%",
                        positiony: "0%",
                        opacity: 0,
                        width: "25%",
                        height: "33.6%",
                        duration: 0,
                      },
                    ],
                  },
                  () => {
                    this.props.onSaveNewAnimation(box.id, []);
                  }
                );
              }}
            >
              {IdealStudio.i18n.t("Animation.animation_reset")}
            </button>
          </Col>
        </Row>
        <Alert
          className="pageModal"
          show={this.state.showAlert}
          hasHeader
          title={i18n.t("marks.wrong_value")}
          closeButton
          onClose={() => {
            this.setState({ showAlert: false });
          }}
        >
          <span> {this.state.alertMsg} </span>
        </Alert>
        <TemplatesModalRich
          show={this.state.showTemplates}
          close={this.toggleTemplatesModal}
          navItems={this.props.navItems}
          boxes={this.props.boxes}
          onIndexSelected={this.props.onIndexSelected}
          indexSelected={this.props.indexSelected}
          onBoxAdded={this.props.onBoxAdded}
          calculatePosition={this.calculatePosition}
          templateClick={this.templateClick}
          idSlide={newId || ""}
        />
      </AppModal>
    );
  }

  /**
   * Mapping method that joins contained views and navItems in array but excluding the ones that can't be
   * @param props Component's props
   * @returns {Array} Array of views
   */
  returnAllViews(props) {
    let viewNames = [];
    props.navItemsIds.map((id) => {
      if (id === 0) {
        return;
      }
      if (props.navItems[id].hidden) {
        return;
      }
      if (!IdealStudio.Config.sections_have_content && isSection(id)) {
        return;
      }
      // We need to turn off this requisite in case there is no more pages available and we need to link to the same page the box is in
      if (props.containedViewSelected === 0 && props.navItemSelected === id) {
        return;
      }

      viewNames.push({ label: props.navItems[id].name, id: id });
    });
    Object.keys(props.containedViews).map((cv) => {
      if (cv === 0) {
        return;
      }

      if (props.containedViewSelected === cv) {
        return;
      }
      viewNames.push({ label: props.containedViews[cv].name, id: props.containedViews[cv].id });
    });
    return viewNames;
  }

  /**
   * Method used to remap navItems and containedViews together
   * @param objects
   * @returns {*}
   */
  remapInObject(...objects) {
    return Object.assign({}, ...objects);
  }
  toggleModal(e) {
    let key = e.keyCode ? e.keyCode : e.which;
    if (key === 27 && this.props.visible) {
      this.props.onAddNewAnimationModalToggled();
    }
  }
  /**
   * Shows/Hides the Import file modal
   */
  toggleTemplatesModal() {
    this.setState((prevState, props) => ({
      showTemplates: !prevState.showTemplates,
    }));
  }
  templateClick(boxes) {
    this.setState({
      boxes: boxes,
    });
  }

  restoreDefaultTemplate() {
    this.setState({
      boxes: [],
    });
  }

  generateTemplateBoxes(boxes, newId) {
    if (boxes.length > 0) {
      boxes.map((item, index) => {
        let position = {
          x: item.box.x,
          y: item.box.y,
          type: "absolute",
        };
        let initialParams = {
          id: ID_PREFIX_BOX + Date.now() + "_" + index,
          parent: newId,
          container: 0,
          col: 0,
          row: 0,
          width: item.box.width,
          height: item.box.height,
          position: position,
          name: item.toolbar.name,
          isDefaultPlugin: true,
          page: newId,
        };
        if (item.toolbar.text) {
          initialParams.text = item.toolbar.text;
        } else if (item.toolbar.url) {
          initialParams.url = item.toolbar.url;
        }
        createBox(
          initialParams,
          item.toolbar.name,
          true,
          this.props.onBoxAdded,
          this.props.boxes,
          item.toolbar.style
        );
      });
    }
  }

  componentDidMount() {
    window.addEventListener("keyup", this.toggleModal);
  }

  componentWillUnmount() {
    window.removeEventListener("keyup", this.toggleModal);
  }
}

AddNewAnimationModal.propTypes = {
  /**
   * Caja seleccionada
   */
  boxSelected: PropTypes.any.isRequired,
  /**
   * Toolbar del plugin
   */
  pluginToolbar: PropTypes.object,
  /**
   * Current selected view (by ID)
   */
  navItemSelected: PropTypes.any.isRequired,
  /**
   * Selected contained view
   */
  containedViewSelected: PropTypes.any.isRequired,
  /**
   * Object containing all contained views (identified by its ID)
   */
  containedViews: PropTypes.object.isRequired,
  /**
   * Object containing all views (by id)
   */
  navItems: PropTypes.object.isRequired,
  /**
   * Indica si se muestra o oculta el modal de edición de marcas
   */
  visible: PropTypes.any.isRequired,
  /**
   * Mark currently being edited
   */
  currentRichMark: PropTypes.any,
  /**
   * Creates a new mark
   */
  onRichMarkAdded: PropTypes.func.isRequired,
  /**
   * Updates a mark
   */
  onRichMarkUpdated: PropTypes.func.isRequired,
  /**
   * Show/hide marks modal form
   */
  onAddNewAnimationModalToggled: PropTypes.any.isRequired,
  /**
   * Cursor value when creating mark (coordinates)
   */
  markCursorValue: PropTypes.any,
  /**
   * Object containing all the marks
   */
  marks: PropTypes.object,
  /**
   * Object containing all the viewTollbars
   */
  viewToolbars: PropTypes.object,
  /**
   *  Object containing all created boxes (by id)
   */
  boxes: PropTypes.object,
  /**
   * Function for adding a new box
   */
  onBoxAdded: PropTypes.func,
  /**
   * Function for getting the id of the selected template
   */
  onIndexSelected: PropTypes.func,
  /**
   * Contains the id of the selected template
   */
  indexSelected: PropTypes.func,
};
